import { useState } from "react"

const EMPTY = { name: "", email: "", phone: "", message: "", website: "" }

// Messages are saved for Admin → Inquiries (with the date and time) and emailed to admin@marafye.com
let HomeContactUs = () => {
  const [form, setForm] = useState(EMPTY)
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState("")

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
    if (error) setError("")
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")
    setSuccess(false)

    if (!form.name.trim()) return setError("Enter your name.")
    if (!/^\S+@\S+\.\S+$/.test(form.email.trim())) return setError("Enter a valid email address.")
    if (form.message.trim().length < 5) return setError("Enter a message.")

    try {
      setLoading(true)
      const res = await fetch(`${process.env.REACT_APP_API_URL}/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      })
      const data = await res.json().catch(() => ({}))
      if (!res.ok) throw new Error(data.message || "Your message couldn't be sent. Please try again.")

      setSuccess(true)
      setForm(EMPTY)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <section className="page-section" id="contact">
      <div className="container">
        <div className="text-center">
          <h2 className="section-heading text-uppercase mt-5 mb-2 fs-1">Contact Us</h2>
          <p className="text-white-50 mb-4">
            Questions about Marafye, becoming a supplier, or an order? Send us a message and we'll get back
            to you by email.
          </p>
        </div>

        <form onSubmit={handleSubmit} noValidate>
          <div className="row g-3 align-items-stretch mb-4">
            <div className="col-md-6 d-flex flex-column gap-3">
              <div>
                <label htmlFor="contact-name" className="visually-hidden">Your name</label>
                <input
                  className="form-control"
                  id="contact-name"
                  name="name"
                  autoComplete="name"
                  maxLength={100}
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Your Name *"
                  required
                />
              </div>
              <div>
                <label htmlFor="contact-email" className="visually-hidden">Your email</label>
                <input
                  className="form-control"
                  id="contact-email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  maxLength={200}
                  value={form.email}
                  onChange={handleChange}
                  placeholder="Your Email *"
                  required
                />
              </div>
              <div>
                <label htmlFor="contact-phone" className="visually-hidden">Your phone (optional)</label>
                <input
                  className="form-control"
                  id="contact-phone"
                  name="phone"
                  type="tel"
                  autoComplete="tel"
                  maxLength={40}
                  value={form.phone}
                  onChange={handleChange}
                  placeholder="Your Phone (optional)"
                />
              </div>

              {/* Hidden from people; bots that fill every field get ignored */}
              <div aria-hidden="true" style={{ position: "absolute", left: "-10000px", width: 1, height: 1, overflow: "hidden" }}>
                <label htmlFor="contact-website">Website</label>
                <input id="contact-website" name="website" tabIndex={-1} autoComplete="off" value={form.website} onChange={handleChange} />
              </div>
            </div>

            <div className="col-md-6">
              <label htmlFor="contact-message" className="visually-hidden">Your message</label>
              <textarea
                className="form-control h-100"
                id="contact-message"
                name="message"
                rows={6}
                maxLength={5000}
                style={{ minHeight: "9rem" }}
                value={form.message}
                onChange={handleChange}
                placeholder="Your Message *"
                required
              />
            </div>
          </div>

          <div aria-live="polite" className="text-center">
            {success && (
              <div className="alert alert-success d-inline-block mb-3">
                Thanks! Your message was sent. We'll reply by email soon.
              </div>
            )}
            {error && <div className="alert alert-danger d-inline-block mb-3">{error}</div>}
          </div>

          <div className="text-center pb-5">
            <button className="btn btn-primary btn-xl text-uppercase" type="submit" disabled={loading}>
              {loading ? "Sending..." : "Send Message"}
            </button>
          </div>
        </form>
      </div>
    </section>
  )
}

export default HomeContactUs
